import API from 'app/gamma/src/api';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { Action, actionCreator } from '@trello/redux';
import { State } from 'app/gamma/src/modules/types';

// Action types
const SELECT_CHANNEL_REQUEST = Symbol('ui/SELECT_CHANNEL_REQUEST');
const SELECT_CHANNEL_ERROR = Symbol('ui/SELECT_CHANNEL_ERROR');
const SELECT_CHANNEL_SUCCESS = Symbol('ui/SELECT_CHANNEL_SUCCESS');

type SelectChannelRequestAction = Action<typeof SELECT_CHANNEL_REQUEST, string>;
type SelectChannelErrorAction = Action<typeof SELECT_CHANNEL_ERROR, Error>;
type SelectChannelSuccessAction = Action<typeof SELECT_CHANNEL_SUCCESS, string>;

// Action creators
export const selectChannelRequest = actionCreator<SelectChannelRequestAction>(
  SELECT_CHANNEL_REQUEST,
);
export const selectChannelError = actionCreator<SelectChannelErrorAction>(
  SELECT_CHANNEL_ERROR,
);
export const selectChannelSuccess = actionCreator<SelectChannelSuccessAction>(
  SELECT_CHANNEL_SUCCESS,
);

export const selectChannel = (channel: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(selectChannelRequest(channel));
    try {
      await API.client.rest.put('members/me/channels/active', {
        query: {
          value: channel,
        },
      });

      dispatch(selectChannelSuccess(channel));
      document.location.reload();
    } catch (err) {
      dispatch(selectChannelError(err));
    }
  };
};
